// Bridges ui.ts's cast handler to GameScene for a Separate·Entropy cast --
// severs an existing Bind·Entropy coupling (see entropyBindEffect.ts). Bind
// creates the coupling, Separate undoes it, the same create/undo shape the
// operator pair already has for Momentum, Energy, Charge and Mass.
//
// The event/result shapes themselves live in rune-lab/src/sim/casts.ts with the
// handler that consumes them, and are re-exported here unchanged, so every
// import site reads them from this module -- the same shape every other
// operator effect's bridge already has.
import { UnbindEntropyEffectEvent, UnbindEntropyEffectResult } from '../../rune-lab/src/sim/casts';

export type { UnbindEntropyEffectEvent, UnbindEntropyEffectResult };

type Handler = (event: UnbindEntropyEffectEvent) => UnbindEntropyEffectResult;

let handler: Handler | null = null;

export function onUnbindEntropyEffect(fn: Handler): void {
  handler = fn;
}

export function triggerUnbindEntropyEffect(event: UnbindEntropyEffectEvent): UnbindEntropyEffectResult {
  return handler ? handler(event) : { applied: false, targetName: '' };
}
